var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M598.94 511.52L1006 104.81a61.23 61.23 0 00-86.71-86.47L511.13 426.13 104.48 18.68a61.19 61.19 0 00-86.56 86.51l406.17 407-406.17 407a61.19 61.19 0 0086.56 86.52l407.29-408.1 407.56 407.09a61.23 61.23 0 0086.67-86.48z",
    fillRule: "evenodd"
  })));
}
export default SvgClose;